define(["react","underscore","prop-types"], function(__WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__9__, __WEBPACK_EXTERNAL_MODULE__10__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1435);
/******/ })
/************************************************************************/
/******/ ({

/***/ 10:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__10__;

/***/ }),

/***/ 1435:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1436);


/***/ }),

/***/ 1436:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "YahooIframe", {
  enumerable: true,
  get: function get() {
    return _index.YahooIframe;
  }
});
Object.defineProperty(exports, "getYahooModel", {
  enumerable: true,
  get: function get() {
    return _yahooCustomerModel.getYahooModel;
  }
});

var _index = __webpack_require__(1437);

var _yahooCustomerModel = __webpack_require__(1439);

/***/ }),

/***/ 1437:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YahooIframe = void 0;

var _react = _interopRequireWildcard(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _constants = __webpack_require__(1438);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

const YahooIframe = ({
  id,
  action,
  jwtToken,
  customerId,
  accountId,
  country,
  locale,
  isProd
}) => {
  const baseHost = isProd ? _constants.BaseHosts.Prod : _constants.BaseHosts.Int;
  const actionEndpoint = `${baseHost}/${_constants.Path}/${_constants.Actions[action]}`;

  const _useState = (0, _react.useState)(),
        _useState2 = _slicedToArray(_useState, 2),
        frameHeight = _useState2[0],
        setFrameHeight = _useState2[1];

  const formRef = (0, _react.useRef)(null);
  (0, _react.useLayoutEffect)(() => {
    formRef.current.submit();

    const callback = evt => {
      if (evt.origin === baseHost && evt.data.action === action) {
        setFrameHeight(`${evt.data.height}px`);
      }
    };

    window.addEventListener('message', callback);
    return () => {
      window.removeEventListener('message', callback);
    };
  }, [action, baseHost]);
  return _react.default.createElement("div", {
    id: id,
    className: "yahoo-iframe-container"
  }, _react.default.createElement("iframe", {
    name: `${id}-frame`,
    id: `${id}-frame`,
    className: "yahoo-iframe",
    style: {
      height: frameHeight
    }
  }), _react.default.createElement("form", {
    name: `${id}-form`,
    id: `${id}-form`,
    method: "POST",
    target: `${id}-frame`,
    action: actionEndpoint,
    ref: formRef
  }, _react.default.createElement("input", {
    type: "hidden",
    name: "jwt",
    value: jwtToken
  }), _react.default.createElement("input", {
    type: "hidden",
    name: "locale",
    value: locale
  }), _react.default.createElement("input", {
    type: "hidden",
    name: "custId",
    value: customerId
  }), _react.default.createElement("input", {
    type: "hidden",
    name: "accountId",
    value: accountId
  }), _react.default.createElement("input", {
    type: "hidden",
    name: "country",
    value: country
  })));
};

exports.YahooIframe = YahooIframe;
YahooIframe.propTypes = {
  id: _propTypes.default.string.isRequired,
  action: _propTypes.default.string.isRequired,
  jwtToken: _propTypes.default.string.isRequired,
  customerId: _propTypes.default.string.isRequired,
  accountId: _propTypes.default.string,
  country: _propTypes.default.string.isRequired,
  locale: _propTypes.default.string.isRequired,
  isProd: _propTypes.default.bool.isRequired
};
YahooIframe.defaultProps = {
  accountId: undefined
};

/***/ }),

/***/ 1438:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YahooDataDisplayHints = exports.Actions = exports.Path = exports.BaseHosts = void 0;
const BaseHosts = {
  Int: 'https://stage.searchads.payments.yahoo.com',
  Prod: 'https://searchads.payments.yahoo.com'
};
exports.BaseHosts = BaseHosts;
const Path = 'api/v1/auth';
exports.Path = Path;
const Actions = {
  SpendAccount: 'spend-account',
  PaymentMethods: 'payment-instruments',
  CompanyInformation: 'company-information',
  BillingReports: 'billing'
};
exports.Actions = Actions;
const YahooDataDisplayHints = {
  // Yahoo! data is not available and should not be attempted to be rendered.
  NotAvailable: 0,
  // Yahoo! data is displayed (instead of Bing Ads data).
  Visible: 1,
  // Yahoo! data is available, but it's not displayed.
  // The user should be allowed to choose between Yahoo! and Bing Ads data.
  Optional: 2
};
exports.YahooDataDisplayHints = YahooDataDisplayHints;

/***/ }),

/***/ 1439:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getYahooModel = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(9));

var _constants = __webpack_require__(1438);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Permissions object defining some features permissions as follows:
 * @typedef {object} Permissions
 * @property {bool} CrossPartnerAgency - true of the customer is opted-in this pilot
 */

/**
 * Create a model for yahoo-customer based on input parameters.
 * @param {bool} isCustomerManagedByYahoo - true if the customer is managed by Y!
 * @param {bool} defaultMSView - true to display microsoft view even if the customer
 *  is managed by yahoo, if permissions. More generally comes from query parameters.
 * @param {bool} isInternalUser - true if the user is internal user
 * @param {Permissions} permissions - object for permissions and features
 * @param {bool} allowYahooCustomerAccessMSView - true to force allowing the user
 *  to display microsoft view for customers managed by yahoo even if permissions are not granted
 * @returns {null} - converted value with appropriate type
 */
const getYahooModel = ({
  isCustomerManagedByYahoo,
  defaultMSView,
  isInternalUser,
  permissions = {},
  allowYahooCustomerAccessMSView
} = {}) => {
  const CrossPartnerAgency = permissions.CrossPartnerAgency;
  const isManagedByYahoo = !!isCustomerManagedByYahoo;
  const isCrossPartnerAgency = !!CrossPartnerAgency;
  const canUserAccessCrossPartnerData = isManagedByYahoo && (isInternalUser || allowYahooCustomerAccessMSView === true) || isCrossPartnerAgency;
  const canUserAccessMicrosoftData = !isManagedByYahoo || canUserAccessCrossPartnerData;
  const canUserAccessYahooData = isManagedByYahoo || canUserAccessCrossPartnerData;
  const canUserSwitchCrossPartnerData = isManagedByYahoo && isInternalUser || isCrossPartnerAgency;

  const getCurrentYahooDisplayHints = () => {
    if (canUserAccessCrossPartnerData) {
      if (_underscore.default.isBoolean(defaultMSView)) {
        return defaultMSView ? _constants.YahooDataDisplayHints.Optional : _constants.YahooDataDisplayHints.Visible;
      } // By default, CrossPartnerAgency should see MSView and others should see YahooView


      return isCrossPartnerAgency ? _constants.YahooDataDisplayHints.Optional : _constants.YahooDataDisplayHints.Visible;
    } else if (isManagedByYahoo) {
      return _constants.YahooDataDisplayHints.Visible;
    }

    return _constants.YahooDataDisplayHints.NotAvailable;
  };

  const currentYahooDisplayHints = getCurrentYahooDisplayHints();
  const showYahooView = currentYahooDisplayHints === _constants.YahooDataDisplayHints.Visible;
  return {
    isManagedByYahoo,
    canUserAccessCrossPartnerData,
    canUserAccessMicrosoftData,
    canUserAccessYahooData,
    canUserSwitchCrossPartnerData,
    currentYahooDisplayHints,
    showYahooView
  };
};

exports.getYahooModel = getYahooModel;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__3__;

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__9__;

/***/ })

/******/ })});;
